import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../Header";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import { useSidebar } from "../../App";

export default function HelpCreatePromptsDocs() {
  const { sidebarCollapsed } = useSidebar();
  const { t } = useTranslation("help");

  return (
    <div className="theme-whbl">
      {/* Internal CSS */}
      <style>
        {`
          .custom_table tr,
          .custom_table th,
          .custom_table td {
            border-bottom: 1px solid #fff;
            padding: 5px;
            text-align: left;
            vertical-align: top;
          }

          .custom_table {
            width: 95%;
            border: 1px solid #ccc;
          }

          .help-row {
            display: flex;
            gap: 16px;
            padding: 16px 18px;
            border-bottom: 1px solid #e5e7eb;
            align-items: flex-start;
          }

          .help-row:last-child {
            border-bottom: none;
          }

          /* 50% TEXT */
          .help-row p {
            width: 100%;
            max-width: 50%;
            margin: 0;
            font-size: 14px;
            line-height: 1.6;
            color: #fff;
          }

          /* 50% IMAGE */
          .help-row img {
            width: 50%;
            max-width: 55%;
            border-radius: 6px;
          }

          /* Mobile */
          @media (max-width: 768px) {
            .help-row {
              flex-direction: column;
            }

            .help-row p,
            .help-row img {
              width: 100%;
              max-width: 100%;
            }
          }
        `}
      </style>

      <div className="container-fluid">
        <div className="main-container">
          <main
            className={`${sidebarCollapsed ? "col-11" : "col-10"}`}
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            <div className="dashboard">
              {/* Page title */}
              <div className="pm-header">
                <h1 className="pm-title">
                  {t(
                    "helpCreatePromptsDocs.title",
                    "Create Malicious Prompt or Docs for Testing"
                  )}
                </h1>
              </div>

              {/* Content */}
              <div className="help-content">
                {/* First Section */}
                <div className="help-row">
                  <p>
                    {t(
                      "helpCreatePromptsDocs.description",
                      "User needs to create prompts according to the defined format and create malicious documents, then save the files."
                    )}
                  </p>

                  <img
                    src="/images/catscat.jpg"
                    alt="Create prompt format"
                  />
                </div>

                {/* Category Section */}
                <div className="help-row">
                  <p>
                    {t(
                      "helpCreatePromptsDocs.categoryDescription",
                      "Currently we support category with exact names as mentioned below."
                    )}

                    <table className="custom_table">
                      <thead>
                        <tr>
                          <th>
                            {t(
                              "helpCreatePromptsDocs.tableHeaders.category",
                              "Category"
                            )}
                          </th>
                          <th>
                            {t(
                              "helpCreatePromptsDocs.tableHeaders.subCategory",
                              "Sub category"
                            )}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {(
                          t("helpCreatePromptsDocs.categories", {
                            returnObjects: true,
                            defaultValue: [
                              {
                                name: "behavioural_threats",
                                subcategories:
                                  "model_drifts, model_poisoning_attempts, multi_step_malicious_intent, model_bias_and_model_influence_attempts",
                              },
                              {
                                name: "input_output_risks",
                                subcategories:
                                  "pii_leakage, confidential_data_leakage_io, output_bias, input_and_output_toxicity",
                              },
                              {
                                name: "malicious_data_insertion",
                                subcategories:
                                  "jailbreak, direct_prompt_injections, indirect_prompt_injections, backdoor_triggers, hidden_intent, contextual_drift",
                              },
                            ],
                          }) || []
                        ).map((cat, idx) => (
                          <tr key={idx}>
                            <td>
                              <b>{cat.name}</b>
                            </td>
                            <td>{cat.subcategories}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </p>

                  <img
                    src={t("helpCreatePromptsDocs.image")}
                    alt="Prompt categories and subcategories"
                  />





                </div>
                <br/><br/>        <img  src={t("helpCreatePromptsDocs.image1")} style={{width:'60%'}}   />
<br/><br/>        <img  src={t("helpCreatePromptsDocs.image2")}  style={{width:'60%'}}   />
<br/><br/>        <img  src={t("helpCreatePromptsDocs.image3")} style={{width:'60%'}}  />
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}